module.exports = __webpack_public_path__ + "static/close-7e3b79be24feaaee0a484d77324b04d9.jpg";